import type { ComponentPropsWithoutRef } from 'react';

import { buttonStyles, type ButtonVariant } from './buttonStyles';

type ButtonProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ButtonVariant;
};

export function Button({ variant = 'encre', type = 'button', className, ...rest }: ButtonProps) {
  return <button type={type} className={buttonStyles(variant, className)} {...rest} />;
}
